// Exports
// -------

// We must use CommonJS module syntax here so this can be imported into Sass files via
// [node-sass-js-importer](https://www.npmjs.com/package/node-sass-js-importer)
module.exports = {
  breakpoints: {
    height: {
      s: `'${ 320/16 }em'`,
      m: `'${ 460/16 }em'`,
      l: `'${ 600/16 }em'`,
      xl: `'${ 750/16 }em'`,
      xxl: `'${ 900/16 }em'`
    },
    width: {
      xxs: `'${ 240/16 }em'`,
      xs: `'${ 300/16 }em'`,
      s: `'${ 440/16 }em'`,
      m: `'${ 600/16 }em'`,
      l: `'${ 750/16 }em'`,
      xl: `'${ 900/16 }em'`,
      xxl: `'${ 1044/16 }em'`,
      xxxl: `'${ 1168/16 }em'`
    }
  }
};
